
/**
 * Increments the order reference number by 1. Used in 3PO payment link
 * @param orderReferenceNumber - The order reference number.
 * @param numberOfRetries - The number of retries.
 * @returns The incremented order reference number.
 */
export function incrementOrderReferenceNumber(orderReferenceNumber: string, numberOfRetries: number): string {

  numberOfRetries = numberOfRetries + 1;

  return orderReferenceNumber + numberOfRetries.toString().padStart(2, '0');
}